import React, { useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { headChat } from "../../../assets/image";
import { BackButton } from "../../../components/micro";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import DatePicker from "react-datepicker";
import { InputError } from "../../../commons/MicroComponents";
import { createServicesRequest } from "../../../redux/serviceRequest/slice";
import { useDispatch, useSelector } from "react-redux";

const ChangeFinancialYearEnd = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const user_id = location?.state?.user_id;
  const company_id = location?.state?.company_id;
  const service = location?.state?.service;
  const buttonRef = useRef(null);

  const createServicesRequestData = useSelector(
    (store) => store?.serviceRequestData?.createServicesRequestStatus?.data
  );
  const createServicesRequestLoading = useSelector(
    (store) => store?.serviceRequestData?.loading
  );

  // Proceed with request
  const handleProceed = (values) => {
    const payload = {
      details: values,
      amount:
        service?.service_requests_count < service?.detail?.no_of_free_request
          ? 0
          : service?.detail?.price,
      user_id: user_id,
      company_id: company_id,
      service_id: service?.id,
    };
    dispatch(createServicesRequest(payload)).then((res) => {
      if (res.type !== "createServicesRequest/fulfilled") return;
      const { service_requests_count, detail } = service || {};
      const price = detail?.price || 0;
      if (
        service_requests_count < service?.detail?.no_of_free_request ||
        price <= 0
      ) {
        navigate("/approver");
      } else if (buttonRef.current) {
        buttonRef.current.click();
      } else {
        navigate("/approver");
      }
    });
  };

  return (
    <div className="space-y-5">
      <BackButton
        onClick={() => {
          navigate("/service");
        }}
      />
      <div className="flex items-center space-x-5 border-b-2 border-secondary_grey pb-7">
        <img src={headChat} alt="img" />
        <div className="space-y-2 font-ebGaramond">
          <p className="text-xl">We see that you will need a request on:</p>
          <p className="text-3xl">Change of Financial Year End</p>
        </div>
      </div>
      {/* Payment Button */}
      <a
        className="hidden"
        ref={buttonRef}
        href={createServicesRequestData?.data?.url}
      >
        Pay Now
      </a>
      <Formik
        initialValues={{
          financial_year_end_date: "",
        }}
        validationSchema={Yup.object().shape({
          financial_year_end_date: Yup.string()
            .nullable()
            .required("Please Select Financial Year End"),
        })}
        onSubmit={handleProceed}
      >
        {({ values, errors, touched, setFieldValue, handleSubmit }) => (
          <Form className="space-y-5" onSubmit={handleSubmit}>
            <div className="space-y-3 border-b-2 border-secondary_grey pb-3">
              <p className="text-2xl font-ebGaramond">
                Let us guide u though the process:
              </p>
              <div className="flex space-x-1 text-theme bg-light_primary_shades rounded-lg px-4 py-3">
                <span>1.</span>
                <p>Let us know which Shareholder's Particulars to change</p>
              </div>
              <p>
                Your Current Financial Year End Date is:{" "}
                <span className="text-theme">DD/MM/YYYY</span>
              </p>
              <p className="text-sm">
                Let us know which period for the Financial Year End you will
                like to change to
              </p>
              <div>
                <div
                  className={
                    errors.financial_year_end_date &&
                    touched.financial_year_end_date &&
                    "input-error"
                  }
                >
                  <DatePicker
                    selected={values.financial_year_end_date}
                    onChange={(date) =>
                      setFieldValue("financial_year_end_date", new Date(date))
                    }
                    selectsStart
                    id="financial_year_end_date"
                    dateFormat="dd/MM/yyyy"
                    placeholderText={"Financial Year End Period"}
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    className={`border border-secondary_grey ${
                      errors.financial_year_end_date &&
                      touched.financial_year_end_date
                        ? "error-forms"
                        : ""
                    } rounded w-full px-3 py-2.5`}
                  />
                </div>
                {errors.financial_year_end_date &&
                touched.financial_year_end_date ? (
                  <InputError errorTitle={errors.financial_year_end_date} />
                ) : null}
              </div>

              <div className="flex space-x-1 text-theme bg-light_primary_shades rounded-lg px-4 py-3">
                <span>2.</span>
                <p>SGCorpHub preparing the director resolution</p>
              </div>
              <div className="flex space-x-1 text-theme bg-light_primary_shades rounded-lg px-4 py-3">
                <span>3.</span>
                <p>Obtain signed resolution</p>
              </div>
              <div className="flex space-x-1 text-theme bg-light_primary_shades rounded-lg px-4 py-3">
                <span>4.</span>
                <p>
                  We will lodge the changes to ACRA for the change of Company
                  Name
                </p>
              </div>
              <p className="text-sm">
                Once the request is opened. You can easily manage it over at
                “On-Going” service page.
              </p>
            </div>
            <div className="flex items-center justify-between space-x-1  bg-light_primary_shades rounded-lg px-4 py-3">
              <p className="font-semibold">Total Payable :</p>
              <div>
                <p className="text-xs">
                  {service?.service_requests_count}/
                  {service?.detail?.no_of_free_request ?? 0} used
                </p>
                <p>
                  {service?.service_requests_count >=
                  service?.detail?.no_of_free_request
                    ? `$${service?.detail?.price}`
                    : "Free"}
                </p>
              </div>
            </div>
            <div className="box !rounded-xl flex items-center justify-between">
              <button
                className={`${
                  createServicesRequestLoading
                    ? "btn-outline-disabled"
                    : "btn-theme"
                } uppercase`}
                disabled={createServicesRequestLoading}
                type="submit"
              >
                {createServicesRequestLoading
                  ? "Loading..."
                  : "Proceed with request"}
              </button>
              <div>
                <p className="text-xs">Total:</p>
                <p>
                  {service?.service_requests_count >=
                  service?.detail?.no_of_free_request
                    ? `$${service?.detail?.price}`
                    : "Free"}
                </p>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default ChangeFinancialYearEnd;
